import React from 'react';
import { useMediaQuery } from 'react-responsive';

import SortingDesktop from './SortingDesktop/SortingDesktop';
import SortingMobile from './SortingMobile/SortingMobile';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import { LARGE_LAPTOP_AND_DESKTOP } from 'settings/mediaQuery';
import { SortingType } from 'types/ProductListing/ProductListing';

type PropsType = {
  sorting: SortingType[];
};

export type SortingChildrenType = PropsType & {
  onSort: (label: string) => void;
};

export default function Sorting(props: PropsType): JSX.Element {
  const isDesktop = useMediaQuery({
    query: LARGE_LAPTOP_AND_DESKTOP,
  });
  const SortingComponent = !isDesktop ? SortingMobile : SortingDesktop;

  function handleSort(label: string) {
    pushGtmEvent({
      event: '_sort',
      page_sort: label,
    });
  }

  return <SortingComponent onSort={handleSort} {...props} />;
}
